import React from 'react'
import logo from '../assets/logo.png' // или ../../assets/logo.png в зависимости от глубины
 // путь зависит от уровня вложенности

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
      <div className="footer-brand">
        <img src={logo}  className="logo-img" />
        {/* <span className="name">LUMABODY</span> */}
      </div>
        <div className="footer-contact">
          <p>📸 <a href="https://instagram.com/luma_body_" target="_blank">@luma_body_</a></p>
          <p>💬 <a href="https://t.me/luma_body" target="_blank">t.me/luma_body</a></p>
        </div>
        <div className="footer-bottom">
          <p>💚 Твой лёгкий путь к телу мечты</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
